import { baseApi } from "@/config/http-common";
import type {
  DashboardDetailsGlobalResponse,
  DashboardDetailType,
  DashboardMainGlobalResponse,
} from "@/types/dashboard/DashboardTypes";

class DashboardDataService {
  getMain(): Promise<{ data: DashboardMainGlobalResponse }> {
    return baseApi.get("/dashboard/main");
  }

  getDetails(params: {
    type: DashboardDetailType;
    page: number;
    size: number;
    templateId?: string;
  }): Promise<{ data: DashboardDetailsGlobalResponse }> {
    return baseApi.get("/dashboard/details", { params });
  }
}

export default new DashboardDataService();
